import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
// import { Forbidden, PageNotFound } from './components';
import PrivateRoutes from '../../PrivateRoutes';

const Forbidden = lazy(()=> import(/* webpackChunkName: "forbidden" */ './components/Forbidden'))
const PageNotFound = lazy(()=> import(/* webpackChunkName: "notfound" */ './components/PageNotFound'))

const routes = () => [
  <PrivateRoutes
    exact={true}
    path='/forbidden'
    key='forbidden'
    component={Forbidden}
  />,
  <PrivateRoutes
    exact={true}
    path='/not-found'
    key='notfound'
    component={PageNotFound}
  />,
];

export default routes;



// WEBPACK FOOTER //
// src/modules/error/routes.js